import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Arrivi senza sapere cosa fare',
  desc: 'Senza sapere quale routine o progressione lavorerai oggi con le tue allieve.'
}, {
  emoji: '⚠️',
  title: 'Tecniche che non progrediscono',
  desc: 'Senza una struttura chiara per passare da un livello al successivo.'
}, {
  emoji: '🩹',
  title: 'Le allieve si infortunano spesso',
  desc: 'Fastidi articolari che non sai come prevenire né correggere.'
}, {
  emoji: '📚',
  title: 'Sempre gli stessi esercizi base',
  desc: 'Non sai come fare la transizione agli esercizi e alle coreografie avanzate.'
}, {
  emoji: '😩',
  title: 'La coreografia perfetta sembra irraggiungibile',
  desc: 'Ti manca un sistema strutturato di progressione coreografica.'
}, {
  emoji: '📱',
  title: 'Consigli sparsi da Instagram',
  desc: 'Senza un metodo chiaro e completo che sostenga il tuo insegnamento.'
}, {
  emoji: '🔄',
  title: 'Non sai come personalizzare',
  desc: "La tua lezione diventa caotica a seconda dell'energia e del livello delle allieve."
}, {
  emoji: '📉',
  title: 'Fine mese senza progressi visibili',
  desc: 'Senza progressione strutturata, le allieve non avanzano e abbandonano.'
}];
export function PainPoints() {
  return <section className="py-16 md:py-24 bg-charcoal text-white" data-id="element-131">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="text-center mb-10 md:mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 md:mb-6 text-ballet-200" data-id="element-134">
            TI SUCCEDE QUESTO?
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-135">
            Se insegni ballet in Italia, questo ti suona familiare:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 md:gap-y-10" data-id="element-136">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-4 items-start group p-4 -mx-4 rounded-2xl transition-colors hover:bg-white/5" data-id="element-137">
              <div className="text-3xl md:text-4xl flex-shrink-0 bg-white/10 p-3 rounded-xl transition-transform duration-300 group-hover:scale-110 group-hover:bg-white/20" data-id="element-138">
                {point.emoji}
              </div>
              <div data-id="element-139">
                <h3 className="text-lg md:text-xl font-bold mb-1 md:mb-2 text-ballet-100 transition-colors group-hover:text-white" data-id="element-140">
                  {point.title}
                </h3>
                <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-141">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 md:mt-20 text-center" data-id="element-142">
          <p className="text-xl md:text-2xl font-serif italic text-ballet-300" data-id="element-143">
            Quanti mesi ancora insegnerai improvvisando?
          </p>
        </div>
      </div>
    </section>;
}